import { render, staticRenderFns } from "./AdminShopOrderEdit.vue?vue&type=template&id=eb6b66e6&scoped=true&"
import script from "./AdminShopOrderEdit.vue?vue&type=script&lang=js&"
export * from "./AdminShopOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminShopOrderEdit.vue?vue&type=style&index=0&id=eb6b66e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6b66e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb6b66e6')) {
      api.createRecord('eb6b66e6', component.options)
    } else {
      api.reload('eb6b66e6', component.options)
    }
    module.hot.accept("./AdminShopOrderEdit.vue?vue&type=template&id=eb6b66e6&scoped=true&", function () {
      api.rerender('eb6b66e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminShopOrderEdit.vue"
export default component.exports